export default __webpack_public_path__ + "static/media/DeusIcon.112c3bf5.svg";